<template>
  <div class="container">
    <br><br>
    <CRow class="text-right">
      <CCol md="12" lg="12" sm="12" xs="12">
        <button @click="mtdBackCampu" type="button" class="btn btn-sm text-white" style="background: #E46666"><i
            class="fas fa-hand-point-left"></i> Cambiar de sede</button>
      </CCol>
    </CRow>
    <br>
    <CRow class="mt-3">
      <CCol xxl="12" xl="12" md="12" sm="12" class="text-center">
        <h4>ESCOJA EL ROL QUE QUIERE EJERCER</h4>
      </CCol>
    </CRow>
    <CRow class="mt-3 d-flex justify-content-center">
      <CCol xl="3" lg="3" md="6" sm="12" v-for="(item, index) in sortedRoles" :key="index">
        <CCard class="mr-1 card text-center" @click="mtdSetRol(item)"
          color="gradient-info" body-wrapper text-color="white">
          {{ item.name }}
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "c-home-campus",
  props: {
    roles: {
      type: Array,
      default: [],
    },
  },
  computed: {
    sortedRoles() {
      return [...this.roles].sort((a, b) => {
        if (a.name === "ADMINISTRADOR") return -1; // "Administrador" siempre primero
        if (b.name === "ADMINISTRADOR") return 1;
        return a.name.localeCompare(b.name);
      });
    },
  },
  methods: {
    mtdSetRol: function (payload) {
      this.$emit("mtdSetRol", payload);
    },
    mtdBackCampu: function () {
      this.$store.commit("mt_set_campu", null);
    }
  },
};
</script>

<style scoped>
.card {
  cursor: pointer;
}
</style>
